module.exports = __webpack_public_path__ + "img/icon-clock-rewind.08420a38.svg";